var _defs, _rect, _circle, _rect2, _text, _circle2, _path, _text2, _text3, _rect3, _text4, _circle3, _circle4, _path2, _text5, _text6, _rect4, _text7, _circle5, _circle6, _circle7, _path3, _text8, _text9, _rect5, _text0, _circle8, _rect6, _path4, _text1, _text10, _rect7, _text11, _circle9, _path5, _text12, _text13, _rect8, _text14, _circle0, _rect9, _circle1, _path6, _text15, _text16, _path7, _path8, _path9, _path0, _path1, _rect0, _circle10, _text17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportReadinessJourneyDeploymentFlowDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1440,
    height: 560,
    viewBox: "0 0 1440 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Work Passport readiness journey desktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "wp-journey-glow"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BCBFF",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BCBFF",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 560,
    rx: 40,
    fill: "#F8FBFE",
    stroke: "#D2E1F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 268.8,
    r: 430,
    fill: "url(#wp-journey-glow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 128,
    width: 194,
    height: 286,
    rx: 24,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 162,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "01")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 218,
    r: 38,
    fill: "#087CFF",
    fillOpacity: 0.11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 231v-27h30v27M133 211h3m5 0h3m5 0h3M123 231h36",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 141,
    y: 286,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "CONFIGURE")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 141,
    y: 326,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 141,
    dy: 0
  }, "Define the site"), /*#__PURE__*/React.createElement("tspan", {
    x: 141,
    dy: 23
  }, "and its rules"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 128,
    width: 194,
    height: 286,
    rx: 24,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 298,
    y: 162,
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "02")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 373,
    cy: 218,
    r: 38,
    fill: "#FF2775",
    fillOpacity: 0.11
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 373,
    cy: 210,
    r: 7,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360 232c1-9 6-13 13-13s12 4 13 13",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 373,
    y: 286,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "MODEL")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 373,
    y: 326,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 373,
    dy: 0
  }, "Set position"), /*#__PURE__*/React.createElement("tspan", {
    x: 373,
    dy: 23
  }, "requirements"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 128,
    width: 194,
    height: 286,
    rx: 24,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 162,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "03")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 605,
    cy: 218,
    r: 38,
    fill: "#74BDFF",
    fillOpacity: 0.11
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 597,
    cy: 211,
    r: 6,
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 615,
    cy: 213,
    r: 5,
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M587 232c2-8 5-12 10-12s9 4 11 12M608 232c1-7 4-10 8-10s8 3 9 10",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 286,
    textAnchor: "middle",
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "ALLOCATE")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 326,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 605,
    dy: 0
  }, "Assign employees"), /*#__PURE__*/React.createElement("tspan", {
    x: 605,
    dy: 23
  }, "to the work"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 128,
    width: 194,
    height: 286,
    rx: 24,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 762,
    y: 162,
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "04")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 837,
    cy: 218,
    r: 38,
    fill: "#F5B642",
    fillOpacity: 0.11
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 823,
    y: 201,
    width: 28,
    height: 34,
    rx: 3,
    fill: "none",
    stroke: "#F5B642",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M830 211h14M830 218h9M830 226l4 4 9-10",
    fill: "none",
    stroke: "#F5B642",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 837,
    y: 286,
    textAnchor: "middle",
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "EVALUATE")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 837,
    y: 326,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 837,
    dy: 0
  }, "Check evidence"), /*#__PURE__*/React.createElement("tspan", {
    x: 837,
    dy: 23
  }, "and validity"))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 972,
    y: 128,
    width: 194,
    height: 286,
    rx: 24,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 994,
    y: 162,
    fill: "#FF6B67",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "05")), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 218,
    r: 38,
    fill: "#FF6B67",
    fillOpacity: 0.11
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1055 230l7-7 7 5 14-18M1076 210h7v7",
    fill: "none",
    stroke: "#FF6B67",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 1069,
    y: 286,
    textAnchor: "middle",
    fill: "#FF6B67",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "RESOLVE")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 1069,
    y: 326,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1069,
    dy: 0
  }, "Close missing or"), /*#__PURE__*/React.createElement("tspan", {
    x: 1069,
    dy: 23
  }, "expiring gaps"))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1204,
    y: 128,
    width: 194,
    height: 286,
    rx: 24,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 1226,
    y: 162,
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "06")), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 1301,
    cy: 218,
    r: 38,
    fill: "#30D6A1",
    fillOpacity: 0.11
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1284,
    y: 205,
    width: 34,
    height: 26,
    rx: 4,
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 1294,
    cy: 215,
    r: 4,
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1288 226c1-5 3-7 6-7s5 2 6 7M1304 213h8M1304 220h8",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 1301,
    y: 286,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "ISSUE")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 1301,
    y: 326,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1301,
    dy: 0
  }, "Release the digital"), /*#__PURE__*/React.createElement("tspan", {
    x: 1301,
    dy: 23
  }, "Work Passport"))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M238 271h36m-8-7 8 7-8 7",
    fill: "none",
    stroke: "#8BCBFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M470 271h36m-8-7 8 7-8 7",
    fill: "none",
    stroke: "#8BCBFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M702 271h36m-8-7 8 7-8 7",
    fill: "none",
    stroke: "#8BCBFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M934 271h36m-8-7 8 7-8 7",
    fill: "none",
    stroke: "#8BCBFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1166 271h36m-8-7 8 7-8 7",
    fill: "none",
    stroke: "#8BCBFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 474,
    width: 1354,
    height: 1,
    fill: "#D2E1F2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 512,
    r: 6,
    fill: "#30D6A1"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 518,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 80,
    dy: 0
  }, "Readiness is issued only after the configured site and position requirements are satisfied."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportReadinessJourneyDeploymentFlowDesktop);
export default __webpack_public_path__ + "static/media/work-passport-readiness-journey-deployment-flow-desktop.33ea35f1b8475e297d09afcf1a61570a.svg";
export { ForwardRef as ReactComponent };